import { render, staticRenderFns } from "./yandex-metrika.vue?vue&type=template&id=49b2b072"
import script from "./yandex-metrika.vue?vue&type=script&lang=js"
export * from "./yandex-metrika.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports